import { Link } from 'react-router-dom';
import { Badges, H4, LI, P, UL } from '../../../AbstractElements';
import SvgIcon from '../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons';
import { Checkall, DeliveryComplete, DeliveryProcessing, Notitications, OrderComplete, TicketsGenerated } from '../../../Utils/Constants';

export default function Notification() {
    return (
        <LI className="onhover-dropdown">
            <div className="notification-box">
                <SvgIcon iconId='Bell'/>
                <Badges color='primary'pill>4 </Badges>
            </div>
            <div className="onhover-show-div notification-dropdown">
                <H4 className="f-18 mb-0 dropdown-title">{Notitications}</H4>
                <UL className='simple-list'>
                    <LI className="b-l-primary bg-light-primary border-4">
                        <P className="font-primary">{DeliveryProcessing} <span className="font-primary">{'10 min.'}</span></P>
                    </LI>
                    <LI className="b-l-secondary bg-light-secondary border-4 mt-3">
                        <P className="font-secondary">{OrderComplete}<span className="font-secondary">{'1 hr'}</span></P>
                    </LI>
                    <LI className="b-l-success bg-light-success border-4 mt-3">
                        <P className="font-success">{TicketsGenerated}<span className="font-success">{'3 hr'}</span></P>
                    </LI>
                    <LI className="b-l-info bg-light-info border-4 mt-3">
                        <P className="font-info">{DeliveryComplete}<span className="font-info">{'6 hr'}</span></P>
                    </LI>
                    <LI><Link className="f-w-700" to={`${process.env.PUBLIC_URL}/applications/chat/chat-private`}>{Checkall}</Link></LI>
                </UL>
            </div>
        </LI>
    )
}
